module.exports = __webpack_public_path__ + "media/images/smartphone_app-06130a19.png";